import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Box, Typography } from "__barrel_optimize__?names=Box,Typography!=!@mui/material";
import { useRouter } from "next/navigation";
import React from "react";
import { Controller } from "react-hook-form";
import StyledDatePicker from "./StyledDatepicker";
import StyledInput from "./StyledInput";
import StyledSelect from "./StyledSelect";
import StyledAutoComplete from "./StylesAutoComplete";
const FormField = (param)=>{
    let { title, type, placeholder, name, error, select, options, control, transform, style, date, searchSelect, additionalOptions, onSelect, translate, dateRange, disablePast, ...rest } = param;
    const router = useRouter();
    return /*#__PURE__*/ _jsxs(Box, {
        width: "100%",
        children: [
            title && /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                mb: "15px",
                color: "#515151",
                children: title
            }),
            date ? /*#__PURE__*/ _jsx(Controller, {
                name: name,
                control: control,
                render: (param)=>{
                    let { field } = param;
                    return /*#__PURE__*/ _jsx(StyledDatePicker, {
                        ...field,
                        error: error,
                        helperText: error === null || error === void 0 ? void 0 : error.message,
                        onChange: (value)=>{
                            onSelect && onSelect(value);
                            field.onChange(value);
                        },
                        disablePast: disablePast
                    });
                }
            }) : searchSelect ? /*#__PURE__*/ _jsx(Controller, {
                name: name,
                control: control,
                render: (param)=>{
                    let { field } = param;
                    const { onInputChange: customOnInputChange, renderInput: customRenderInput, renderOption: customRenderOption, ...otherProps } = rest || {};
                    const selectOptions = options || [];
                    const autocompleteOptions = (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.length) ? [
                        ...selectOptions,
                        ...additionalOptions
                    ] : selectOptions;
                    return /*#__PURE__*/ _jsx(StyledAutoComplete, {
                        ...field,
                        ...otherProps,
                        onChange: (event, newValue)=>{
                            if (typeof newValue === "string") {
                                // Custom typed value
                                onSelect && onSelect(newValue); // Pass the custom value to onSelect
                                field.onChange({
                                    label: newValue,
                                    value: null,
                                    product_name: newValue
                                }); // Update field with custom value
                            } else if (newValue && newValue.redirect) {
                                router.push(newValue.redirect);
                            } else {
                                // Selected from list
                                onSelect && onSelect(newValue);
                                field.onChange(newValue);
                            }
                        },
                        onInputChange: (event, newInputValue, reason)=>{
                            // Call custom onInputChange if provided
                            if (customOnInputChange) {
                                // When custom handler is provided, update field to show typed value FIRST
                                // This ensures the field value is updated before custom handler runs
                                if (newInputValue) {
                                    field.onChange({
                                        label: newInputValue,
                                        value: null,
                                        product_name: newInputValue
                                    });
                                } else {
                                    field.onChange(null);
                                }
                                // Then call custom handler (which may set additional fields like productName)
                                customOnInputChange(event, newInputValue, reason);
                            } else {
                                // Default behavior: only update if typing something not in options
                                if (newInputValue && !selectOptions.some((option)=>option.label === newInputValue)) {
                                    onSelect && onSelect(newInputValue);
                                    field.onChange({
                                        label: newInputValue,
                                        value: null,
                                        product_name: newInputValue
                                    });
                                }
                            }
                        },
                        options: autocompleteOptions,
                        placeholder: placeholder,
                        getOptionLabel: (option)=>option.label || "",
                        isOptionEqualToValue: (option, value)=>option.value === value.value,
                        freeSolo: true,
                        renderOption: customRenderOption || ((props, option)=>{
                            const isActionOption = Boolean(option.redirect);
                            return /*#__PURE__*/ _createElement("li", {
                                ...props,
                                key: option.value || option.redirect || option.label,
                                style: {
                                    ...props.style,
                                    ...isActionOption ? {
                                        borderTop: "1px solid #E0E0E0",
                                        color: "#515151",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        marginTop: "4px"
                                    } : {}
                                }
                            }, isActionOption ? /*#__PURE__*/ _jsxs(Box, {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                children: [
                                    /*#__PURE__*/ _jsx(Box, {
                                        component: "span",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        bgcolor: "#FFF4E6",
                                        color: "#FF9F24",
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        children: "+"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: option.label || option.redirect || ""
                                    })
                                ]
                            }) : option.label || option.redirect || "");
                        }),
                        renderInput: customRenderInput || ((params)=>/*#__PURE__*/ _jsx(StyledInput, {
                                ...params,
                                error: error,
                                sx: {
                                    "& legend": {
                                        display: "none"
                                    },
                                    "& fieldset": {
                                        top: 0
                                    }
                                }
                            })),
                        error: error,
                        helperText: error === null || error === void 0 ? void 0 : error.message
                    });
                }
            }) : select ? /*#__PURE__*/ _jsx(Controller, {
                name: name,
                control: control,
                render: (param)=>{
                    let { field } = param;
                    return /*#__PURE__*/ _jsx(StyledSelect, {
                        ...field,
                        ...rest,
                        onChange: (e)=>{
                            onSelect && onSelect(e.target.value);
                            field.onChange(e.target.value);
                        },
                        fullWidth: true,
                        type: type,
                        placeholder: placeholder,
                        options: options,
                        error: error,
                        helperText: error === null || error === void 0 ? void 0 : error.message,
                        style: style,
                        translate: translate
                    });
                }
            }) : /*#__PURE__*/ _jsx(Controller, {
                name: name,
                control: control,
                render: (param)=>{
                    let { field } = param;
                    const { onChange: additionalOnChange, onKeyDown: additionalOnKeyDown, ...inputProps } = rest || {};
                    const handleChange = (event)=>{
                        if (transform) {
                            const formattedValue = transform(event.target.value);
                            field.onChange(formattedValue);
                        } else {
                            field.onChange(event);
                        }
                        additionalOnChange === null || additionalOnChange === void 0 ? void 0 : additionalOnChange(event);
                    };
                    const handleBackspaceAtEnd = (inputElement)=>{
                        const currentValue = inputElement.value || "";
                        const trimmedValue = currentValue.trim();
                        if (!trimmedValue.endsWith("€")) {
                            return false;
                        }
                        const isNegative = trimmedValue.startsWith("-");
                        const digits = currentValue.replace(/[^0-9]/g, "");
                        if (!digits.length) {
                            field.onChange("");
                            requestAnimationFrame(()=>{
                                inputElement.setSelectionRange(0, 0);
                            });
                            return true;
                        }
                        const shortenedDigits = digits.slice(0, -1);
                        const nextValue = shortenedDigits ? transform(isNegative ? "-".concat(shortenedDigits) : shortenedDigits) : "";
                        field.onChange(nextValue);
                        requestAnimationFrame(()=>{
                            const caretPosition = nextValue ? nextValue.length : 0;
                            inputElement.setSelectionRange(caretPosition, caretPosition);
                        });
                        return true;
                    };
                    const handleKeyDown = (event)=>{
                        if (transform && event.key === "Backspace") {
                            const inputElement = event.target;
                            const { selectionStart, selectionEnd } = inputElement;
                            const hasSelection = selectionStart !== null && selectionEnd !== null && selectionStart !== selectionEnd;
                            const caretAtEnd = selectionStart !== null && selectionEnd !== null && selectionStart === selectionEnd && selectionEnd === inputElement.value.length;
                            if (!hasSelection && caretAtEnd && handleBackspaceAtEnd(inputElement)) {
                                event.preventDefault();
                                return;
                            }
                        }
                        additionalOnKeyDown === null || additionalOnKeyDown === void 0 ? void 0 : additionalOnKeyDown(event);
                    };
                    var _field_value;
                    return /*#__PURE__*/ _jsx(StyledInput, {
                        ...field,
                        ...inputProps,
                        fullWidth: true,
                        type: type,
                        placeholder: placeholder,
                        error: error,
                        value: (_field_value = field.value) !== null && _field_value !== void 0 ? _field_value : "",
                        helperText: error === null || error === void 0 ? void 0 : error.message,
                        style: style,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown
                    });
                }
            })
        ]
    });
};
export default FormField;
